export default __webpack_public_path__ + "static/media/radio-checked.6d74c2ea.svg";